/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'facebook': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M13.667 9.564v-1.67c0-.723.17-1.112 1.36-1.112H16.5V4h-2.267c-2.833 0-3.966 1.836-3.966 3.895v1.669H8v2.781h2.267v8.346h3.4v-8.345h2.493l.34-2.782h-2.833z" _fill="#81899D"/>'
  }
})
